import { PropsWithChildren } from 'react'

const AutocallForm = ({ children }: PropsWithChildren) => {
  return <div className="autocall-form">{children}</div>
}

export default AutocallForm
